module.exports = __webpack_public_path__ + "static/media/anatolii-cat-1.5fcd5545.jpg";